<template>
  <div class="modal" :id="`modal-help`">
    <div class="modal-background" v-on:click="closeModal"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <div  class="modal-card-title">
          <div>Помощь</div>
          <br>
          <div class="buttons tags">
            <div class="button tag" :class="page === 'home' ? 'my-btn-select' : 'my-not-selected'" v-on:click="page = 'home'">Начало</div>
            <div class="button tag" :class="page === 'show&search' ? 'my-btn-select' : 'my-not-selected'" v-on:click="page = 'show&search'">Поиск и просмотр</div>
            <div class="button tag" :class="page === 'create' ? 'my-btn-select' : 'my-not-selected'" v-on:click="page = 'create'">Создание</div>
          </div>
        </div>
        <button class="delete" aria-label="close" v-on:click="closeModal"></button>
      </header>
      <section class="modal-card-body">
        <Home v-if="page==='home'" />
        <ShowSearch v-if="page==='show&search'" />
        <Create v-if="page==='create'" />
      </section>
    </div>
  </div>
</template>

<script>
import Home from "@/components/HelpPages/Home";
import ShowSearch from "@/components/HelpPages/Show&Search";
import Create from "@/components/HelpPages/Create";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Help",
  components: {Create, Home,ShowSearch},
  data() {
    return {
      page: 'home'
    }
  },
  methods: {
    closeModal: function () {
      let modal = document.getElementById(`modal-help`)
      if (modal.classList.toString().includes('is-active')) {
        modal.classList.remove('is-active')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.my-btn-select {
  background-color: #ffffff;
  text-decoration: underline 1px dashed rgb(45, 140, 0);
}
.my-not-selected {
  border: 1px dashed rgba(0,0,0,0.1) !important;
}
</style>